// language=GraphQL
export const ALL_TENANT_CONTENTS_QUERY = `query Query {
  tenantContents: tenantContents {
    id
    bookingInsuranceInfo
  }
}`

// language=GraphQL
export const SINGLE_TENANT_CONTENT_QUERY = `query Query($id: ID!) {
  tenantContent: tenantContent(id: $id) {
    id
    bookingInsuranceInfo
  }
}`

// language=GraphQL
export const CREATE_TENANT_CONTENT_MUTATION = `
  mutation Mutation($input: CreateTenantContentInput) {
    tenantContent: createTenantContent(input: $input) {
      id
      bookingInsuranceInfo
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_CONTENT_MUTATION = `
  mutation Mutation($input: UpdateTenantContentInput) {
    tenantContent: updateTenantContent(input: $input) {
      id
      bookingInsuranceInfo
    }
  }`

// language=GraphQL
export const DELETE_TENANT_CONTENT_MUTATION = `
  mutation Mutation($input: DeleteTenantContentInput) {
    deleteTenantContent(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TENANT_CONTENT_MUTATION = `
  mutation Mutation($input: DeleteTenantContentInput) {
    forceDeleteTenantContent(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TENANT_CONTENTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: tenantContentDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
